import {
  LOCALE_EN,
  LOCALE_JA,
  LOCALE_KO,
  LOCALE_VI,
  LOCALE_ZH_CHS,
  LOCALE_ZH_CHT,
  LocaleType,
} from '../../../modules/i18n/config'
import { STUDENT_BTN_ID } from '../../../modules/ids/gtm/student'

export interface IMenuItem {
  id: STUDENT_BTN_ID
  label: string
  href: IMenuHref | null
}

export interface IMainMenuItem extends IMenuItem {
  isEvent: boolean
  subMenu: ISubMenu[] | null
}

export type IMainMenu = IMainMenuItem[]

export interface ISubMenu {
  subMenuSectionTitle: string | null
  subMenuList: IMenuItem[]
}

export interface IMenuHref {
  url: string
  type: MENU_HREF_TYPE
  locale: LocaleType | null
}

export enum MENU_HREF_TYPE {
  WITHIN,
  OUTBOUND,
  LOCALE_CHANGE,
  LOGOUT,
}

export const MENU_HREF_LOCALE: Record<string, LocaleType | null> = {
  CURRENT: null,
  EN: LOCALE_EN,
  KO: LOCALE_KO,
  JA: LOCALE_JA,
  ZH_CHS: LOCALE_ZH_CHS,
  ZH_CHT: LOCALE_ZH_CHT,
  VI: LOCALE_VI,
}

export enum NAVIGATION_BAR_HREF_TYPE {
  WITHIN,
  OUTBOUND,
  DROPDOWN,
}

export enum BOTTOM_NAVIGATION_ITEM_ID {
  HOME,
  MATERIAL,
  TUTOR,
  PRICING,
  HELP,
  PROMOTION,
}

export interface INavigationBarItem {
  id: STUDENT_BTN_ID
  href: string
  type: NAVIGATION_BAR_HREF_TYPE
  isVisible: boolean
}

export interface IBottomNavigationBarItem extends INavigationBarItem {
  itemId: BOTTOM_NAVIGATION_ITEM_ID
}

export interface IHeaderNavigationBarItem extends INavigationBarItem {
  title: string
  inActiveTextColor: string
  activeTextColor: string
  isVisible: boolean
  list: INavigationBarItem[]
}
